/// <amd-module name="Artifacts/Root/components/DefaultLoader" />
import { CenteredSpinner } from "Artifacts/Root/components/CenteredSpinner";
import { ComponentStateSwitch } from "Artifacts/Root/components/ComponentStateSwitch";
import { ComponentState } from "Artifacts/Root/Constants";
import * as Res from "Artifacts/Root/Resources";
import * as React from "react";
import { ZeroData } from "VSSUI/ZeroData";

interface IDefaultLoaderProps {
  state: ComponentState;
  noLoadingSpinner?: boolean;
  spinnerLabel?: string;
  primaryText?: string;
}

/**
 * DefaultLoader renders a centered loading spinner when loading and a zero data
 * component in the case of a failure. Use this for page loads where a failure means
 * no content on the page can be displayed
 */
const DefaultLoader: React.FC<IDefaultLoaderProps> = ({
  state,
  noLoadingSpinner = false,
  children,
  spinnerLabel,
  primaryText,
}) => (
  <ComponentStateSwitch
    state={state}
    loading={noLoadingSpinner ? children : <CenteredSpinner label={spinnerLabel} />}
    ready={children}
    error={
      <ZeroData
        primaryText={primaryText || Res.GenericError}
        secondaryText={state.errorMessage || Res.GenericError_Details}
        imagePath={""}
        imageAltText={""}
      />
    }
  />
);

export { DefaultLoader };
